module.exports = __webpack_public_path__ + "img/ui_nike_flair_a.9fedb3c0.png";